export default [
  { title: 'Orders', routeName: 'cryptomats-orders' },
  { title: 'Fees and limits', routeName: 'cryptomats-fees' },
  { title: 'Transactions', routeName: 'cryptomats-transactions' },
  { title: 'ATMs', routeName: 'cryptomats-atms' },
  { title: 'Currencies', routeName: 'cryptomats-currencies' },
  { title: 'Renters', routeName: 'cryptomats-renters' },
  { title: 'Checks', routeName: 'cryptomats-сhecks' },
];

